export enum CalendarTypes {
  Google,
  ICal,
  Outlook,
  Yahoo
}
